import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledDialogTitle = styled(Typography)(({ theme, titleColor }) => ({
  color: titleColor || theme.palette.primary.main,
  fontWeight: 'bold',
  fontSize: '1.5rem',
  padding: '16px 24px 8px 24px',
  margin: 0,
  textAlign: "center"
}));

const StyledSeparator = styled('hr')(({ theme, separatorColor }) => ({
  border: 'none',
  borderTop: `1px solid ${separatorColor || theme.palette.primary.main}`,
}));

const DialogTitle = ({ 
  children, 
  titleColor,
  separatorColor,
  showSeparator = true,
  sx = {},
  ...props 
}) => {
  return (
    <Box>
      <StyledDialogTitle titleColor={titleColor} sx={sx} {...props}>
        {children}
      </StyledDialogTitle>
      {showSeparator && <StyledSeparator separatorColor={separatorColor} />}
    </Box>
  );
};

export default DialogTitle;